import React from 'react';

import { useTranslation } from 'react-i18next';

export type AttachmentRow = { label: string; value: React.ReactNode };

const AttachmentCard: React.FC<{
  icon?: React.ReactNode;
  title: string;
  rows: ReadonlyArray<AttachmentRow>;
  onRemove: () => void;
  removeAriaLabel: string;
}> = ({ icon, title, rows, onRemove, removeAriaLabel }) => {
  const { t } = useTranslation('pleri/chat');
  return (
    <div className="group relative">
      <div className="inline-flex max-w-[28rem] min-w-[18rem] flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-900">
        <div className="flex items-center gap-2 px-3 py-2">
          <div className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-lg bg-blue-100 text-blue-600 dark:bg-blue-900">
            {icon}
          </div>
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <span
                className="truncate text-sm font-medium text-gray-900 dark:text-gray-100"
                title={title}
              >
                {title}
              </span>
            </div>
          </div>
          <button
            type="button"
            onClick={onRemove}
            className="ml-2 inline-flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full bg-black/70 text-white transition hover:bg-black"
            title={t('common:remove')}
            aria-label={removeAriaLabel}
          >
            <svg
              className="h-3 w-3"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        {rows.length > 0 && (
          <div className="grid grid-cols-2 gap-x-4 gap-y-2 border-t border-gray-100 px-3 py-2 text-xs dark:border-gray-800">
            {rows.map((row) => (
              <div
                key={`${row.label}:${String(typeof row.value === 'string' ? row.value : row.label)}`}
                className="flex items-center gap-1 truncate"
                title={typeof row.value === 'string' ? row.value : undefined}
              >
                <span className="text-gray-500 dark:text-gray-400">
                  {row.label}:
                </span>
                <span className="truncate font-medium text-gray-900 dark:text-gray-100">
                  {row.value}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AttachmentCard;
